"use client";

import { BaseLink } from "@components/core/Link";
import IconChevronDownSmall from "@ui/central-icons/icons/IconChevronDownSmall";
import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import type { LinkProps } from "@/i18n/navigation";
import { clsx } from "clsx";
import type { CSSProperties } from "react";
import { Button, Disclosure, DisclosurePanel } from "react-aria-components";

export function FooterCollapsibleItem({
  label,
  links,
  linkStyleProps,
}: {
  label: string;
  links: LinkProps[];
  linkStyleProps: {
    style?: CSSProperties;
    className?: string;
  };
}) {
  if (links.length === 0) {
    return null;
  }

  return (
    <Disclosure className='tw-group'>
      {({ isExpanded }) => (
        <>
          <Button
            slot='trigger'
            className={clsx(
              "tw-appearance-none tw-border-0 tw-bg-transparent tw-group/trigger",
              "tw-flex tw-w-fit tw-items-center",
              "tw-rounded tw-transition-colors tw-outline-none focus-visible:tw-outline-focus focus-visible:tw-outline-offset-0",
              "tw-px-1.5 -tw-mx-1.5",
            )}
            style={linkStyleProps.style}
          >
            <span className={linkStyleProps.className}>{label}</span>
            <IconChevronDownSmall
              aria-hidden
              className={clsx(
                iconStrokeFix,
                "tw-ml-1 tw-size-4 tw-flex-none tw-shrink-0 tw-transition-transform motion-safe:tw-duration-300 motion-safe:tw-ease-in-out",
                isExpanded && "tw-rotate-180",
                isExpanded ? "tw-text-black" : "tw-text-gray-500 group-hover/trigger:tw-text-black",
              )}
            />
          </Button>
          <DisclosurePanel
            className={clsx(
              "motion-safe:tw-transition-[height,opacity] motion-safe:tw-ease-in-out motion-safe:tw-duration-300 tw-overflow-clip",
              !isExpanded && "tw-opacity-0",
            )}
            style={{ height: "var(--disclosure-panel-height)" }}
          >
            <ul role='list' className='tw-m-0 tw-p-0 tw-pl-3'>
              {links.map((link, index) => (
                <li key={index}>
                  <BaseLink {...link} {...linkStyleProps} />
                </li>
              ))}
            </ul>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}
